import { render, staticRenderFns } from "./p-home.vue?vue&type=template&id=f3f4931c&"
import script from "./p-home.vue?vue&type=script&lang=js&"
export * from "./p-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports